/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./product-view.vue?vue&type=template&id=3d0044cf&scoped=true&"
import script from "./product-view.vue?vue&type=script&lang=ts&"
export * from "./product-view.vue?vue&type=script&lang=ts&"
import style0 from "./product-view.vue?vue&type=style&index=0&id=3d0044cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0044cf",
  null
  
)

export default component.exports